var _excluded = ["data"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import { bool, string, shape } from 'prop-types';
import styled from 'styled-components';
import Text from '../../Text';
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  width: 95px;\n  position: absolute;\n  bottom: 30px;\n  left: 6px;\n\n  transform: translateX(-50%);\n\n  ", "\n"])), function (_ref) {
  var hasRibbon = _ref.hasRibbon,
      slider = _ref.theme.yoga.components.slider;
  return "\n    background-color: " + (hasRibbon ? slider.tooltip.ribbon.backgroundColor : slider.tooltip.backgroundColor) + ";\n    border-radius: " + slider.tooltip.radius + "px;\n    box-shadow: " + slider.tooltip.shadow + ";\n  ";
});
Wrapper.propTypes = {
  hasRibbon: bool
};
Wrapper.defaultProps = {
  hasRibbon: false
};
var Tip = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  z-index: 3;\n\n  ", "\n"])), function (_ref2) {
  var slider = _ref2.theme.yoga.components.slider;
  return "\n    background-color: " + slider.tooltip.backgroundColor + ";\n    border-radius: " + slider.tooltip.radius + "px;\n    padding: " + slider.tooltip.padding.top + "px " + slider.tooltip.padding.right + "px " + slider.tooltip.padding.bottom + "px " + slider.tooltip.padding.left + "px;\n  ";
});
var Arrow = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  bottom: -5px;\n  left: 50%;\n  z-index: 2;\n\n  width: 16px;\n  height: 16px;\n\n  border-radius: 3px;\n\n  transform: rotate(45deg) translateX(-50%);\n  transform-origin: left;\n\n  ", "\n"])), function (_ref3) {
  var _ref3$theme$yoga$comp = _ref3.theme.yoga.components.slider.tooltip,
      backgroundColor = _ref3$theme$yoga$comp.backgroundColor,
      shadow = _ref3$theme$yoga$comp.shadow;
  return "\n    background-color: " + backgroundColor + ";\n    box-shadow: " + shadow + ";\n  ";
});
var Ribbon = styled(Text.Bold)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  text-align: center;\n  display: block;\n\n  ", "\n"])), function (_ref4) {
  var slider = _ref4.theme.yoga.components.slider;
  return "\n    padding: " + slider.tooltip.ribbon.padding.top + "px " + slider.tooltip.ribbon.padding.right + "px " + slider.tooltip.ribbon.padding.bottom + "px " + slider.tooltip.ribbon.padding.left + "px;\n\n    border-top-left-radius: " + slider.tooltip.ribbon.radius + "px;\n    border-top-right-radius: " + slider.tooltip.ribbon.radius + "px;\n    color: " + slider.tooltip.ribbon.font.color + ";\n\n    font-size: " + slider.tooltip.ribbon.font.size + "px;\n  ";
});
var Title = styled(Text.Small)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  display: block;\n  text-align: center;\n  ", "\n"])), function (_ref5) {
  var slider = _ref5.theme.yoga.components.slider;
  return "\n    color: " + slider.tooltip.font.color + ";\n    font-weight: " + slider.tooltip.font.title.weight + ";\n  ";
});
var Description = styled(Text.Small)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  display: block;\n  text-align: center;\n  ", "\n"])), function (_ref6) {
  var slider = _ref6.theme.yoga.components.slider;
  return "\n    color: " + slider.tooltip.font.color + ";\n    font-weight: " + slider.tooltip.font.description.weight + ";\n  ";
});

var Tooltip = function Tooltip(_ref7) {
  var data = _ref7.data,
      props = _objectWithoutPropertiesLoose(_ref7, _excluded);

  return Object.keys(data).length ? /*#__PURE__*/React.createElement(Wrapper, _extends({
    hasRibbon: Boolean(data.ribbon)
  }, props), data.ribbon && /*#__PURE__*/React.createElement(Ribbon, {
    as: "span"
  }, data.ribbon), (data.title || data.description) && /*#__PURE__*/React.createElement(Tip, null, data.title && /*#__PURE__*/React.createElement(Title, {
    as: "span"
  }, data.title), data.description && /*#__PURE__*/React.createElement(Description, {
    as: "span"
  }, data.description)), /*#__PURE__*/React.createElement(Arrow, null)) : null;
};

Tooltip.propTypes = {
  data: shape({
    ribbon: string,
    title: string,
    description: string
  })
};
Tooltip.defaultProps = {
  data: {}
};
export default Tooltip;